import { ImageName } from "./ImageName";

export class ImageNameUtil {
    /**
     * Converts a string to a valid ImageName value if it exists, otherwise returns null
     * @param value The string value to convert
     * @returns The corresponding ImageName enum value, or null if not found
     */
    public static fromString(value: string): ImageName {
        // Check if the value exists as a key in the ImageName enum
        if (this.isValidName(value)) {
            return ImageName[value as keyof typeof ImageName];
        }
        return null;
    }

    /**
     * Checks if a string is a valid ImageName key
     * @param value The string value to check
     * @returns True if the value is a valid ImageName key, false otherwise
     */
    public static isValidName(value: string): value is keyof typeof ImageName {
        return value in ImageName;
    }
}
